import React, { useState } from 'react';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';

import { ErrorHandler } from '@playbookux/playbook-web-core';
import withDashboardSidebar from '../../components/with-dashboard-sidebar';
import FilterableGrid from '../../../core/components/filterable-grid';

import {
  columns,
  getPaginatedProjects,
  keys,
} from './utils';

import {
  Container,
  ContainerError,
  Title,
} from './styles';

const Projects = () => {
  const [errors, setErrors] = useState();

  const handleApiCall = (params) => getPaginatedProjects(params);

  if (errors) {
    return (
      <ContainerError>
        <ErrorHandler
          error={errors}
          defaultMessage="Error while retrieving projects."
        />
      </ContainerError>
    );
  }

  return (
    <Container>
      <Title>
        Projects
      </Title>

      <FilterableGrid
        defaultColumns={columns}
        keyFilters={keys}
        onHandleApiCall={handleApiCall}
        onSetErrors={setErrors}
        order="created_at DESC"
      />
    </Container>
  );
};

Projects.propTypes = {};

export default compose(
  withDashboardSidebar,
  withRouter,
)(Projects);
